import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "../Actions/UsersActions";

const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  header: {},
  data: [],
  usersStatus: [],
  lastPage: false,
};

const UsersStore = useGlobalHook(React, initialState, actions);

export default UsersStore;
